// Catálogo compartilhado (carrinho + página de coleções). Preço "null" = ainda não confirmado.
window.VIEIRA_CATALOG = {
  categories: [
    { slug: "anel-solitario", name: "Anel Solitário", image: "assets/img/colecao-anel-solitario.jpg" },
    { slug: "alianca-de-namoro", name: "Aliança de Namoro", image: "assets/img/colecao-alianca-de-namoro.jpg" },
    { slug: "personalizados", name: "Personalizados", image: "assets/img/colecao-personalizados.jpg" },
    { slug: "pingentes", name: "Pingentes", image: "assets/img/colecao-pingentes.jpg" },
    { slug: "brincos", name: "Brincos", image: "assets/img/colecao-brincos.jpg" },
    { slug: "pulseiras", name: "Pulseiras", image: "assets/img/colecao-pulseiras.jpg" },
  ],
  products: [
    {
      id: "anel-x",
      name: "Anel X",
      category: "anel-solitario",
      price: 270.0,
      image: "assets/img/anel-x-still-frontal.jpg",
      gallery: [
        "assets/img/anel-x-still-frontal.jpg",
        "assets/img/anel-x-still-lateral.jpg",
        "assets/img/anel-x-still-interior.jpg",
        "assets/img/anel-x-macro-pedra.jpg",
        "assets/img/anel-x-macro-cravejado.jpg",
      ],
    },
    {
      id: "alianca-de-namoro",
      name: "Aliança de Namoro",
      category: "alianca-de-namoro",
      price: null,
      image: "assets/img/colecao-alianca-de-namoro.jpg",
    },
    {
      id: "personalizados",
      name: "Personalizados",
      category: "personalizados",
      price: null,
      image: "assets/img/colecao-personalizados.jpg",
    },
    {
      id: "pingentes",
      name: "Pingentes",
      category: "pingentes",
      price: null,
      image: "assets/img/colecao-pingentes.jpg",
    },
    {
      id: "brincos",
      name: "Brincos",
      category: "brincos",
      price: null,
      image: "assets/img/colecao-brincos.jpg",
    },
    {
      id: "pulseiras",
      name: "Pulseiras",
      category: "pulseiras",
      price: null,
      image: "assets/img/colecao-pulseiras.jpg",
    },
  ],
};
